import { jsx, jsxs } from "react/jsx-runtime";
import { FormHelperText } from "@mui/material";
import { Select as SelectComponent } from "@workwave-tidal/core/components/Select";
import { useFormFairyBridge } from "../../hooks/useFormFairyBridge.js";
import { FormUIFormControl } from "../primitives/FormUIFormControl.js";
function Select(props) {
  const { selectProps, ...bridgeOptions } = props;
  const {
    config: { fullWidth, testId = "select-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onBlur,
      onChange,
      onFocus,
      showErrorAccent,
      showHelperText,
      value
    }
  } = useFormFairyBridge(bridgeOptions);
  if (!visible) return null;
  const handleOnChange = (nextValue) => {
    onChange(nextValue);
  };
  return /* @__PURE__ */ jsxs(
    FormUIFormControl,
    {
      error: showErrorAccent && fieldHasError,
      fullWidth,
      "data-testid": testId,
      "data-tidal": "Select",
      children: [
        /* @__PURE__ */ jsx(
          SelectComponent,
          {
            ...selectProps,
            error: showErrorAccent && fieldHasError,
            value,
            onBlur,
            onFocus,
            onChange: handleOnChange,
            required,
            disabled: fieldDisabled
          }
        ),
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  );
}
export {
  Select
};
//# sourceMappingURL=SelectField.js.map
